import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  arrowIcon: {
    transform: ({ direction }) => {
      let degrees;

      switch (direction) {
        case "left":
          degrees = 90;
          break;

        case "up":
          degrees = -180;
          break;

        case "right":
          degrees = -90;
          break;

        case "down":
          degrees = 0;
          break;

        default:
          degrees = 0;
      }

      return `rotate(${degrees}deg)`;
    },
    fill: "none",
    strokeLinejoin: "round",
    strokeWidth: "1.42px",
    strokeLinecap: "round",
    stroke: "currentColor",
    opacity: ({ disabled }) => (disabled ? 0.4 : 1),
  },
});

function ArrowIcon({ direction = "left", disabled = false, size = 12 }) {
  const classes = useStyles({ direction, disabled });

  return (
    <svg
      className={classes.arrowIcon}
      width={size * 1.87}
      height={size}
      viewBox="0 0 21.36 11.42"
    >
      <polyline points="0.71 0.71 10.71 10.71 20.65 0.77" />
    </svg>
  );
}

ArrowIcon.propTypes = {
  direction: PropTypes.oneOf(["left", "up", "right", "down"]),
  disabled: PropTypes.bool,
  size: PropTypes.string,
};

export default ArrowIcon;
